import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "@/lib/api";

const AuthCtx = createContext(null);

const POST_LOGIN_LOADER_MS = 3000;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  // True for a couple of seconds right after a fresh login — drives the
  // branded loader overlay in App.js. Never set on the silent /auth/me
  // check at app startup, only on an actual login submission.
  const [justLoggedIn, setJustLoggedIn] = useState(false);

  useEffect(() => {
    if (!getToken()) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { setToken(null); setUser(false); });
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.access_token);
    setUser(data.user);
    setJustLoggedIn(true);
    setTimeout(() => setJustLoggedIn(false), POST_LOGIN_LOADER_MS);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    setToken(null);
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, login, logout, justLoggedIn }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
